<template>
  <div class="col-sm-12 nopads" style="overflow: visible;">
    <span :class="searchTitleStyle ? 'search-title' : 'span-title mt-0'">{{ $t('materialstorage.title') }}</span>
    <multiselect
      v-model="selectedStorage"
      class="multiselect_routa"
      :placeholder="$t('materialstorage.select_storage')"
      :deselect-label="$t('common.remove_selection')"
      :select-label="$t('common.select')"
      :close-on-select="false"
      :multiple="true"
      label="name"
      track-by="name"
      :searchable="true"
      :internal-search="true"
      maxHeight="200"
      :selected-label="$t('common.selected')"
      :options="storages"
    >
      <template
        #singleLabel="props"
      >
        <span class="option__desc">
          <span class="option__title">{{ props.option.name }}</span>
        </span>
      </template>
      <template
        #option="props"
      >
        <div class="option__desc">
          <span class="option__title multiselect_detail_block">{{ props.option.name }}</span>
        </div>
      </template>
      <template #noResult>
        <span>{{ $t('common.not_found') }}</span>
      </template>
      <template #noOptions>
        <span>{{ $t('common.no_results') }}</span>
      </template>
    </multiselect>
  </div>
</template>

<script>
import {timeUtils} from '../mixins/TimeUtils'
import {restApi} from '../mixins/RestApiMixin'

export default {
    name: 'MaterialStorageFilter',
    mixins: [timeUtils, restApi],
    props: {
        modelValue: {
            type: Array,
            default: null
        },
        searchTitleStyle: {
            type: Boolean,
            default: false
        }
    },
    data: function () {
        return {
            selectedStorage: [],
            storages: []
        }
    },
    watch: {
        modelValue: function (value) {
            if (!value || !value.length) {
                this.selectedStorage = []
            }
        },
        selectedStorage: function (value) {
            if (this.storages && this.storages.length > 0) {
                this.$emit('update:modelValue', value && value.length ? value.map(s => s.id) : null)
                this.$emit('storage-selected', value && value.length ? value : null)
            }
        },
        modelValue: function (value) {
            if (!value) {
                this.selectedStorage = null
            }
        }
    },
    mounted: function () {
       this.fetchStorages()
    },
    methods: {
        fetchStorages: function () {
            this.storages = []
            this.restFetch(this.materialStorageSearchListUrl, this.handleStorages)
        },
        handleStorages: function (response) {
            if (response && response.data) {
                const sortedAplhabetically = response.data.sort((a, b) => a.name.localeCompare(b.name))
                this.storages = sortedAplhabetically
            }
            if (this.selectedStorage && this.selectedStorage.length) {
                this.selectedStorage = this.selectedStorage.filter(s => this.storages.find(item => item.id === s.id))
            }
            this.$emit('loadingCompleted')
        }
    }
}
</script>
